export default val => (
  val !== 'false' && val !== 'FALSE' && !!val
);
